<ng-container *ngFor="let card of page?.helper?.reviewableCards">
  <cu-dynamic-card-review [card]="card" [page]="page" [flow]="flow" ></cu-dynamic-card-review>
</ng-container>
